<template>
  <path
    d="M17.63 7.00018H6.37C3.96 7.00018 2 9.24018 2 12.0002C2 14.7602 3.96 17.0002 6.37 17.0002H17.63C20.04 17.0002 22 14.7602 22 12.0002C22 9.24018 20.04 7.00018 17.63 7.00018ZM11.11 10.6002L7.6 14.1102C7.5 14.2102 7.37 14.2602 7.25 14.2602C7.13 14.2602 6.99 14.2102 6.9 14.1102L5.04 12.2502C4.84 12.0502 4.84 11.7402 5.04 11.5402C5.24 11.3402 5.55 11.3402 5.75 11.5402L7.26 13.0502L10.42 9.89018C10.62 9.69018 10.93 9.69018 11.13 9.89018C11.33 10.0902 11.3 10.4002 11.11 10.6002Z"
  />
</template>
